<button #wideTrigger type="button" class="eg-input eg-topbar__search id-search-trigger" aria-haspopup="dialog" [attr.aria-expanded]="open()" [attr.aria-label]="placeholder()" [attr.aria-keyshortcuts]="shortcut.aria" (click)="openPalette()">
    <i class="ph-fill ph-magnifying-glass" aria-hidden="true"></i>
    <span class="id-search-trigger__text">{{ placeholder() }}</span>
    <kbd class="id-kbd" aria-hidden="true">{{ shortcut.label }}</kbd>
</button>
<button
    #compactTrigger
    type="button"
    class="eg-btn eg-btn--ghost eg-btn--icon id-search-trigger-compact"
    aria-haspopup="dialog"
    [attr.aria-expanded]="open()"
    [attr.aria-label]="placeholder()"
    [attr.aria-keyshortcuts]="shortcut.aria"
    [egTooltip]="placeholder()"
    [egTooltipShortcut]="shortcut.label"
    (click)="openPalette()"
>
    <i class="ph-fill ph-magnifying-glass eg-topbar__glyph" aria-hidden="true"></i>
</button>

@if (open()) {
    <div class="id-palette-backdrop" data-palette-backdrop (click)="close()"></div>
    <div class="id-palette" role="dialog" aria-modal="true" [attr.aria-label]="i18n.t('search.dialog')" (keydown)="onPaletteKeydown($event)" (mousedown)="keepFocus($event)">
        <div class="id-palette__field">
            <i class="ph-fill ph-magnifying-glass" aria-hidden="true"></i>
            <input
                #input
                type="text"
                class="id-palette__input"
                role="combobox"
                aria-autocomplete="list"
                [attr.aria-expanded]="visibleGroups().length > 0"
                [attr.aria-controls]="listboxId"
                [attr.aria-activedescendant]="activeOption()?.key ?? null"
                [attr.aria-label]="placeholder()"
                [placeholder]="placeholder()"
                autocomplete="off"
                spellcheck="false"
                [value]="term()"
                (input)="onInput($any($event.target).value)"
            />
            <kbd class="id-kbd" aria-hidden="true">Esc</kbd>
        </div>

        <div class="id-palette__body">
            <div role="listbox" class="id-palette__list" [id]="listboxId" [attr.aria-label]="i18n.t('search.results')">
                @for (group of visibleGroups(); track group.key) {
                    <div role="group" class="id-palette__group" [attr.data-group]="group.key" [attr.aria-labelledby]="'id-search-group-' + group.key">
                        <div role="presentation" class="id-palette__group-head">
                            <span class="eg-eyebrow" [id]="'id-search-group-' + group.key">{{ i18n.t(group.label) }}</span>
                            @if (shownOf(group); as count) {
                                <span class="id-palette__count">{{ count }}</span>
                            }
                        </div>
                        @switch (group.state.status) {
                            @case ('loading') {
                                <div class="id-palette__skeleton" data-state="loading" aria-hidden="true">
                                    <span class="id-skeleton id-skeleton--line" style="width: 58%"></span>
                                    <span class="id-skeleton id-skeleton--line" style="width: 40%"></span>
                                </div>
                            }
                            @case ('error') {
                                <div role="presentation" class="id-palette__note id-palette__note--bad" data-state="error"><i class="ph-fill ph-warning-circle" aria-hidden="true"></i>{{ i18n.t('search.failed') }}</div>
                            }
                            @default {
                                @for (option of group.options; track option.key) {
                                    <div role="option" class="id-palette__option" [id]="option.key" [attr.aria-selected]="option.key === activeOption()?.key" (mousemove)="activeKey.set(option.key)" (click)="activate(option)">
                                        <i class="ph-fill id-palette__icon" [class]="group.icon" aria-hidden="true"></i>
                                        <span class="id-palette__text">
                                            <span class="id-palette__name">{{ label(option.hit) }}</span>
                                            @if (option.hit.meta) {
                                                <span class="id-palette__meta">{{ option.hit.meta }}</span>
                                            }
                                        </span>
                                    </div>
                                } @empty {
                                    <div role="presentation" class="id-palette__note" data-state="empty">{{ i18n.t('search.empty') }}</div>
                                }
                            }
                        }
                    </div>
                }
            </div>
            @if (visibleGroups().length === 0) {
                <p class="id-palette__note" data-state="hint">{{ i18n.t('search.hint') }}</p>
            }
        </div>

        <div class="id-palette__foot" aria-hidden="true">
            <kbd class="id-kbd">↑</kbd><kbd class="id-kbd">↓</kbd><span>{{ i18n.t('search.keys.navigate') }}</span> <kbd class="id-kbd">Enter</kbd><span>{{ i18n.t('search.keys.open') }}</span> <kbd class="id-kbd">Esc</kbd
            ><span>{{ i18n.t('search.keys.close') }}</span>
        </div>
        <div class="sr-only" role="status" aria-live="polite" aria-atomic="true">{{ announcement() }}</div>
    </div>
}
